import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useActionToast } from '@/Hooks/useActionToast';
import { deleteTour } from '../Services/Tours.service';
import { toursQueryKeys } from '../Constants/queryKeys';

export const useDeleteTour = () => {
  const queryClient = useQueryClient();
  const toast = useActionToast();

  return useMutation({
    mutationFn: deleteTour,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: toursQueryKeys.lists() });
      toast.success('Tour excluído');
    },
    onError: (error: Error) => {
      toast.failure('Não foi possível excluir o tour', error);
    },
  });
};
